import { marketingService } from "./api";
import {
  getLandingSlug,
  getReferralCode,
  getUtmParams,
} from "./campaignAttribution";

function buildAttributionPayload(extra = {}) {
  const referral = getReferralCode();
  const utm = getUtmParams();
  const payload = { ...utm, ...extra };

  if (referral) {
    payload.referral_code = referral;
    payload.referred_by = referral;
  }

  Object.keys(payload).forEach((key) => {
    if (payload[key] == null || payload[key] === "") delete payload[key];
  });

  return payload;
}

/**
 * Registra conversión de registro para campaña `/welcome/:slug`.
 * No bloquea el flujo del usuario si falla.
 */
export async function trackLandingRegistration(extra = {}) {
  const slug = getLandingSlug();
  if (!slug) return { skipped: true };

  try {
    return await marketingService.trackRegistration(
      slug,
      buildAttributionPayload(extra)
    );
  } catch (err) {
    if (process.env.NODE_ENV === "development") {
      console.warn("[landing] track_registration failed:", err);
    }
    return { ok: false };
  }
}

/**
 * @param {"play_store"|"app_store"} platform
 */
export async function trackLandingDownload(platform) {
  const slug = getLandingSlug();
  if (!slug) return { skipped: true };

  try {
    return await marketingService.trackDownload(slug, {
      platform,
      store: platform,
    });
  } catch (err) {
    if (process.env.NODE_ENV === "development") {
      console.warn("[landing] track_download failed:", err);
    }
    return { ok: false };
  }
}
